import { Typography } from "@mui/material";



const Copyright = (props: any) => {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            Copyright &copy; EMC 2022.
        </Typography>
    );
}

export default Copyright